export const CLAIM_TYPE = {
  MEDICAL: 'medical',
  PHARMACY: 'pharmacy'
}

export const CLAIM_STATUS_CODES = {
  PAID: 'PAID',
  DENIED: 'DENIED',
  IN_REVIEW: 'IN_REVIEW',
  RECEIVED_IN_PROCESS: 'RECEIVED_IN_PROCESS',
  PROCESSED: 'PROCESSED',
  REVERSED: 'REVERSED'
}
